import { OrderStatus } from '../types/OrderStatus'
import { InvoiceFlags } from '../constants'
import { OrderDto, OrderSummaryDto } from '../types/swaggerTypes'

/**
 * Checks if an order is eligible for invoice download based on its status and invoice flag
 * @param order The order to check (can be either OrderDto or OrderSummaryDto)
 * @returns boolean indicating if the order is eligible for invoice download
 */
export const isOrderEligibleForInvoice = (
  order?: OrderDto | OrderSummaryDto
): boolean => {
  if (!order?.orderStatus) {
    return false
  }

  // For OrderSummaryDto, we need to check the invoiceFlag from the 'any' type
  // For OrderDto, we can check it directly
  const invoiceFlag =
    'invoiceFlag' in order ? order.invoiceFlag : (order as any).invoiceFlag

  if (invoiceFlag !== InvoiceFlags.Y.toString()) {
    return false
  }

  const eligibleStatuses = [
    OrderStatus.Shipped,
    OrderStatus.Delivered,
    OrderStatus.InTransit,
    OrderStatus.OutForDelivery,
    OrderStatus.FailedAttempt,
    OrderStatus.Failed_Attempt,
    OrderStatus.AvailableForPickup
  ]

  return eligibleStatuses.some(
    (status) => order.orderStatus === status.toString()
  )
}
